import React from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";
import { selectSelected } from "./taxOldSlice";
import { useHistory } from "react-router-dom";
import { formatDate ,formatCurrency} from "../../../utility";

export const TaxOldDetail = () => {
  const history = useHistory();
  const items = useSelector(selectSelected);

  // Return if data null
  if (items === null) {
    history.push("/master/sap-tax-old");
  }

  return items === null ? null : (
    <Card>
      <CardHeader title="Tax Old Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            {/* kanan */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Client</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.client} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>FK</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.fk} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Plant Code</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.plantCode} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Billing Doc</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.billingDoc} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Disc Channel</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.distrChannel} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Date</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={formatDate(items.date)} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Material</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.item} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Tax Class 1 Cust</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.taxClass1Cust} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Fg Pegngganti</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.fgPengganti} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Tax Invoice Number</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.taxInvoiceNumber} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Current Period</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.currentPeriod} disabled />
                </Col>
              </Form.Group>
            </Col>
            {/* kiri */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Year Cur Period</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.yearCurPeriod} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Fully Vasted On</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.fullyVestedOn} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Sales Office</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.salesOffice} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Acct At Cust</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.acctAtCust} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Vat Reg No</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.vatRegNo} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.name} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Street</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.street} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Subtotal 5</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={formatCurrency(items.subtotal5)} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Amount 1</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={formatCurrency(items.amount)} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Amount</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={formatCurrency(items.amount2)} disabled />
                </Col>
              </Form.Group>
              {/* <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Id Ket Tambahan</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control value={items.idKeteranganTambahan} />
                </Col>
              </Form.Group> */}
            </Col>
          </Form.Group>
        </Form>{" "}
        <Row className="mt-6">
          <Button
            variant="light"
            className="mr-3"
            onClick={() => history.push("/master/sap-tax-old")}
          >
            <i className="fa fa-arrow-left" />
            Back
          </Button>
        </Row>
      </CardBody>
    </Card>
  );
};
